import { BcfAppId } from '@bcf-v2-configurators/tokens/app/types';

export const bcfAppId: BcfAppId = 'sb-lvbetlv-mobile-web-twa';
